<template>
    <v-dialog v-model="show" width="40vw" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable persistent>
        <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
            <v-card-title class="text-h5 lighten-2"> Eliminar dirección </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col>
                            <span class="text-subtitle-1" v-if="addressSelected">
                                ¿Seguro que quiere eliminar la dirección <span class="font-italic font-weight-bold">
                                    "{{ addressSelected.name }}"
                                </span> ?
                            </span>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-container>
                    <v-row>
                        <v-col>
                            <v-btn color="red" block @click="closeModal()" dark :disabled="isLoading">Cancelar</v-btn>
                        </v-col>
                        <v-col>
                            <v-btn color="primary" block @click="confirmation" :loading="isLoading">Eliminar</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
//vuex
import { mapActions, mapState, mapMutations } from "vuex";
//validations
import { requiredValidation } from "@/helpers/validations.js";
export default {
    data: () => ({
        isLoading: false,
        form: {
            nickname: null,
            address: null,
            phone: null,
            email: null,
            contact: null,
        }
    }),
    props: {
        value: Boolean,
    },
    computed: {
        ...mapState("address", ["addressSelected"]),
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    methods: {
        ...mapActions("address", ["deleteAddress"]),
        ...mapMutations("address", ["SET_ADDRESS"]),
        closeModal() {
            this.SET_ADDRESS(null)
            this.show = false;
        },
        async confirmation() {
            //emit fetch table
            try {
                this.isLoading = true;
                await this.deleteAddress(this.addressSelected._id);
                this.$swal({
                    icon: "success",
                    title: `Dirección eliminada`,
                    showConfirmButton: false,
                    timer: 500,
                });
                this.$emit("update");
                this.closeModal()
            } catch (error) {
                console.log(error);
                this.$swal({
                    icon: "error",
                    title: `Algo salio mal al. Error: ${error.message}`,
                    showConfirmButton: false,
                    timer: 2000,
                });
            } finally {
                this.isLoading = false;
            }
        },
        validation(name) {
            return requiredValidation(name);
        },
    },
};
</script>
